/* eslint-disable camelcase */

import { useQuery } from 'react-query'
import { client } from './AxiosClient'
import { KEYS } from './keys'

const isBrowser = typeof window !== 'undefined'

const getBrandingTenantFromHostname = () => {
  if (isBrowser) {
    return {
      dnsCname: window.location.hostname.replace(/\..*/, ''),
      hostname: window.location.hostname
    }
  } else {
    return { dnsCname: 'app', hostname: 'NOT_PROVIDED' }
  }
}

export const useGetCnameBrandingQuery = () => {
  const { dnsCname, hostname } = getBrandingTenantFromHostname()

  return useQuery(KEYS.BRANDING_CNAME(dnsCname), () => {
    return client.get(`/api/v2/branding/app?dnsCname=${dnsCname}&hostname=${hostname}`).then(res => res.data)
  }, {
    staleTime: 1000 * 60,
    cacheTime: 1000 * 60,
    placeholderData: {
      dnsCname: 'app',
      companyLogo: undefined,
      companyName: 'ReflowHub',
      companyTagline: 'Device lifecycle, simplified.',
      companyColour: '#A70F4C',
      emailTemplateListId: 'List Number',
      emailTemplateSignOff: 'The ReflowHub Team'
    }
  })
}
